import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { HrefDirective, IconComponent } from '@tdwb/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective,
    HrefDirective,
    IconComponent,
    NgxTranslatePipe,
    NgxTranslatePipe
  ],
  selector: 'td-wb-modal-notification-ofi-open-banking',
  templateUrl: 'modal-notification-ofi-open-banking.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss',
    'modal-notification-ofi-open-banking.component.scss'
  ]
})
export class ModalNotificationOfiOpenBankingComponent {
}
